import { ViewType } from "@common/types/views/views";
import {
    BankReconciliationColumn,
    BankReconciliationView,
} from "./bankReconciliationView";

export const defaultBankReconciliationView: BankReconciliationView = {
    type: ViewType.BANK_RECONCILIATION,
    options: {
        selection: false,
        bulkActions: false,
    },
    columns: [
        {
            id: BankReconciliationColumn.ACCOUNT_NAME,
        },
        {
            id: BankReconciliationColumn.START_DATE,
        },
        {
            id: BankReconciliationColumn.BEGINNING_BALANCE,
        },
        {
            id: BankReconciliationColumn.END_DATE,
        },
        {
            id: BankReconciliationColumn.ENDING_BALANCE,
        },
        {
            id: BankReconciliationColumn.CONTINUOUS_RECONCILIATION,
        },
        {
            id: BankReconciliationColumn.ENTITY,
        },
        {
            id: BankReconciliationColumn.ACTIONS,
            options: {
                pin: "right",
            },
        },
    ],
    filters: {},
};

export const singleEntityBankReconciliationView: BankReconciliationView = {
    ...defaultBankReconciliationView,
    columns: defaultBankReconciliationView.columns.filter(
        (column) => column.id !== BankReconciliationColumn.ENTITY,
    ),
};
